export const BLOG_ARTICLES = "/blog/articles/";
export const BLOG_ARTICLE = "/blog/article/";
